import { render, staticRenderFns } from "./ChatNotification.vue?vue&type=template&id=54681fc5&"
import script from "./ChatNotification.vue?vue&type=script&lang=js&"
export * from "./ChatNotification.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotification.vue?vue&type=style&index=0&id=54681fc5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports